import { Point, FloorPlanElement } from '../types';
import { PIXELS_PER_METER } from '../constants/floorPlanConstants';
import { SmokeAlarmElement } from '../types';

export function createSmokeAlarmElement(point: Point, floor: number): SmokeAlarmElement {
  return {
    id: `smoke-alarm-preview-${Date.now()}`,
    type: 'smoke-alarm',
    position: point,
    floor,
  };
}

function drawSAText(ctx: CanvasRenderingContext2D, center: Point, size: number) {
    const originalFont = ctx.font;
    ctx.font = `bold ${size}px Arial`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('SA', center.x, center.y);
    ctx.font = originalFont;
}

export function drawSmokeAlarms(
  ctx: CanvasRenderingContext2D,
  elements: FloorPlanElement[],
  currentFloor: number,
  scale: number,
  viewOffset: Point
) {
  const smokeAlarmElements = elements.filter(
    (el): el is SmokeAlarmElement => el.type === 'smoke-alarm' && el.floor === currentFloor
  );

  if (smokeAlarmElements.length === 0) return;

  ctx.save();
  // Canvas context is already transformed, no need to apply transformation again

  ctx.fillStyle = '#ef4444'; // Red-500

  smokeAlarmElements.forEach(alarm => {
    const size = (0.2 * PIXELS_PER_METER) / scale; // 20cm size for the text, adjusted for scale
    drawSAText(ctx, alarm.position, size);
  });

  ctx.restore();
}

export function drawSmokeAlarmPreview(
    ctx: CanvasRenderingContext2D,
    preview: SmokeAlarmElement | null,
    scale: number,
    viewOffset: Point
) {
    if (!preview) return;

    ctx.save();
    // Canvas context is already transformed, no need to apply transformation again
    
    ctx.globalAlpha = 0.6;
    ctx.fillStyle = '#ef4444';

    const size = (0.2 * PIXELS_PER_METER) / scale;
    drawSAText(ctx, preview.position, size);

    ctx.restore();
} 